import React, { useEffect, useState } from 'react';
import { Button, Spin } from 'antd';
import { MODEL_INSPECTOR_URL, LOG_EMBED_URL, BRAND_ID_MAPPING, getPlatformSpecificBaseURL, GET_PRODUCT_URL } from '../Constants';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { unhashCompanyId } from '../helperFunctions';
import './ProductPublicViewer.css';

const ProductPublicViewer = () => {
    
    const [productId, setProductId] = useState(null);
    const [isPhoneDevice, setIsPhoneDevice] = useState(false);
    const [glbUrl, setGlbUrl] = useState(null);
    const [platform, setPlatform] = useState(null);
    const [baseUrl, setBaseUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [companyEnvironmentHDR, setCompanyEnvironmentHDRQuery] = useState('');

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const isAiModel = queryParams.get('ai_model') === 'true';
    const hideAR = queryParams.get('hide_ar') === 'true';
    const hideGizmo = queryParams.get('hide_gizmo') === 'true';
    const autoRotation = queryParams.get('auto_rotation') === 'true';
    const autoRotationSpeed = queryParams.get('auto_rotation_speed') || 1;
    const debugMode = queryParams.get('debug_mode') === 'true';
    const environmentHDRQuery = queryParams.get('env');
    let envParam = ''

    if (environmentHDRQuery) {
        envParam = `&env=${environmentHDRQuery}`
    }

    useEffect(() => {
        setIsPhoneDevice(/Android|iPhone|iPad|iPod/i.test(navigator.userAgent));
        let payload = {};
        if (id) {
            payload.product_id = id;
        }
        if (isAiModel) {
            payload.ai_model = true;
        }

        axios.post(GET_PRODUCT_URL, payload).then(response => {
            if (response.data.statusCode === 200) {
                setGlbUrl(response.data.body.glbUrl);
                setPlatform(response.data.body.platform);
                setProductId(parseInt(response.data.body.productId));
                setCompanyEnvironmentHDRQuery(response.data.body.companyHdri);
            } else {
                if (debugMode) {
                    console.log("Error fetching product data:", response.data);
                }
                setIsError(true);
            }
        });

        const referrer = document.referrer;
        if (referrer !== "") {
            if (debugMode) {
                console.log("Embedded by:", referrer);
            }
            axios.post(LOG_EMBED_URL, {
                referrer: referrer,
                productId: productId
            });
        }
    }, []);

    useEffect(() => {
        if (platform) {
            setBaseUrl(getPlatformSpecificBaseURL(platform));
        }
    }, [platform]);

    const getGLBUrl = () => {
        return isAiModel
            ? `${baseUrl}product_assets/ai_generated_glb/${productId}.glb`
            : `${baseUrl}product_assets/glb/${productId}.glb`;
    };

    const getUSDZUrl = () => {
        return isAiModel
            ? `${baseUrl}product_assets/ai_generated_usdz/${productId}.usdz`
            : `${baseUrl}product_assets/usdz/${productId}.usdz`;
    };

    const getAndroidIntentUrl = () => {
        const fileUrl = getGLBUrl();
        return `intent://arvr.google.com/scene-viewer/1.0?file=${fileUrl}&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;end;`;
    };

    const openAr = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPhone|iPad|iPod/i.test(userAgent)) {
            window.location.href = getUSDZUrl();
        } else if (/android/i.test(userAgent)) {
            window.location.href = getAndroidIntentUrl();
        } else {
            alert("AR is only supported on Android and iOS devices.");
        }
    };
    return (
        <>
        { productId && !isError &&
        <div className='model-viewer-public' style={{ display: isLoading ? 'none' : 'block' }}>
            <div className='viewer-iframe-container'>
                <iframe
                    id='model-viewer-3d'
                    className='model-inspector-frame'
                    src={`${MODEL_INSPECTOR_URL}${productId}&hide_gizmo=${isPhoneDevice||hideGizmo}&auto_rotation=${autoRotation}&auto_rotation_speed=${autoRotationSpeed}${envParam}`}
                    onLoad={() => {
                        const iframe = document.getElementById('model-viewer-3d');
                        if (!iframe || !iframe.contentWindow) {
                            if (debugMode) {
                                console.log('Iframe or contentWindow not available');
                            }
                            return;
                        }
                        setTimeout(() => {
                            try {
                                const message = { 
                                    type: 'loadModel',
                                    glbURL: glbUrl,
                                    debugMode: isAiModel ? true : false
                                };
                                if (companyEnvironmentHDR) {
                                    message.hdri = companyEnvironmentHDR
                                }
                                if (debugMode) {
                                    console.log("Sending message to iframe:", message);
                                }
                                
                                window.addEventListener('message', function debugMessage(event) {
                                    if (debugMode) {
                                        console.log('Received message from iframe:', event.data);
                                    }
                                    if (event.source === iframe.contentWindow) {
                                        window.removeEventListener('message', debugMessage);
                                    }
                                });

                                iframe.contentWindow.postMessage(message, "*");
                                setIsLoading(false);
                            } catch (error) {
                                if (debugMode) {
                                    console.error('Error sending message:', error);
                                }
                            }
                        }, 1000);
                    }}
                />
            </div>
            {isPhoneDevice && !hideAR &&
                <div className='view-ar-btn'>
                    <Button className="add-model-button font-12-em" onClick={openAr}>
                        <img src='/img/ar.png' alt="View in AR" />
                        View in AR
                    </Button>
                </div>}
        </div>
        }
        {
            isLoading && !isError &&
            <div className='loading-container'>
                <div className='loading-spinner'>
                    <Spin />
                </div>
                <div className='loading-text'>Loading your 3D Experience...</div>
            </div>
        }
        {
            isError &&
            <div className='error-container'>
                <div className='error-text'>Error loading your 3D Experience.</div>
            </div>
        }
        </>
    );
};

export default ProductPublicViewer;
